import { Component } from "react";
import {
  Carousel,
  CarouselControl,
  CarouselItem,
  Modal,
  ModalBody,
} from "reactstrap";
import * as Scrivito from "scrivito";

class LightboxCarusel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.activeImage,
      isDescriptionVisible: false,
    };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  toggleDescription = () => {
    this.setState((state) => ({
      isDescriptionVisible: !state.isDescriptionVisible,
    }));
  };

  next() {
    if (this.animating) {
      return;
    }

    const nextIndex = (this.state.activeIndex + 1) % this.props.images.length;
    this.setState({ activeIndex: nextIndex, isDescriptionVisible: false });
  }

  previous() {
    if (this.animating) {
      return;
    }

    let previousIndex = (this.state.activeIndex - 1) % this.props.images.length;
    if (previousIndex < 0) {
      previousIndex = this.props.images.length - 1;
    }
    this.setState({ activeIndex: previousIndex, isDescriptionVisible: false });
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  render() {
    const { images } = this.props;
    return (
      <Modal
        isOpen={true}
        className="lightbox border-0 "
        size="lg"
        toggle={this.props.toggleLightbox}
      >
        <button className="close-button" onClick={this.props.toggleLightbox}>
          x
        </button>

        <div className="lightbox-container ">
          <ModalBody className="content ">
            <Carousel
              activeIndex={this.state.activeIndex}
              next={this.next}
              previous={this.previous}
              interval={false}
              slide={false}
              className="border-0"
            >
              {images.map((image, index) => (
                <CarouselItem
                  onExiting={this.onExiting}
                  onExited={this.onExited}
                  key={`${image.id()}${index}`}
                  className=""
                >
                  <Scrivito.ImageTag
                    onClick={this.toggleDescription}
                    content={image}
                    alt={image.get("alternativeText")}
                    className="image-tag"
                    loading="lazy"
                    width={image?.metadata().get("width")}
                    height={image?.metadata().get("height")}
                  />
                  {this.state.isDescriptionVisible &&
                    image.get("alternativeText") && (
                      <div className="p-2 ms-4 desc-text">
                        <div className="me-2">
                          <span className="h5">{image.get("title")}</span>
                          <span className="d-block">
                            {image.get("alternativeText")}
                          </span>
                        </div>
                      </div>
                    )}
                </CarouselItem>
              ))}

              <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={this.previous}
              />
              <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={this.next}
              />
            </Carousel>
            <a
              className="las la-download  text-light pt-3 opacity06 download"
              href={Scrivito.urlFor(images[this.state.activeIndex])}
              download="image.jpg"
            />
          </ModalBody>
        </div>
      </Modal>
    );
  }
}

export default Scrivito.connect(LightboxCarusel);
